/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e){return null!=e&&"object"==typeof e&&"2d"===e.type&&"linkchart"===e.view2dType}export{e as isLinkChartView};
